import { fetchWrapper } from "@/helpers/fetch-wrapper";
import FiltersService from "@/services/FiltersService";

class LocationStatuses {
  getLocations() {
    return FiltersService.getLocations();
  }

  // Najnowszy status każdej lokalizacji, która ma dane (pomija puste). Pozwala ukryć puste
  // stacje oraz sortować po czasie ostatniej aktualizacji / dostępności bez rozwijania każdej.
  getOverview() {
    return fetchWrapper.get(`${process.env.VUE_APP_API_URL}/locations/statuses/overview`);
  }

  getLatestByLocation(locationId) {
    return fetchWrapper.get(`${process.env.VUE_APP_API_URL}/locations/${locationId}/statuses/latest`);
  }

  getHistoryByLocation(locationId, { page = 1, limit = 100, orderDirection = "desc" } = {}) {
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      orderDirection: String(orderDirection).toLowerCase() === "asc" ? "asc" : "desc",
    });

    return fetchWrapper.get(
      `${process.env.VUE_APP_API_URL}/locations/${locationId}/statuses?${params.toString()}`
    );
  }
}

export default new LocationStatuses();
